import { render } from "./BookmarkedPosts.vue?vue&type=template&id=58c1e649"
import script from "./BookmarkedPosts.vue?vue&type=script&lang=js"
export * from "./BookmarkedPosts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__